import { DatePipe } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { SystemMessage } from 'app/core/system-message/system-message-service';
import { WidgetExpiredMedicationVm } from 'app/shared/generated/Administration/Models/Users/WidgetExpiredMedicationVm';
import { ResizableWidgetComponent } from '../resizable-widget/resizable-widget.component';
import { LinkComponent } from 'app/shared/link/link.component';

@Component({
    selector: 'pcg-expiring-meds-widget',
    imports: [
        DatePipe,
        FontAwesomeModule,
        NgbTooltip,

        LinkComponent,
        ResizableWidgetComponent
    ],
    templateUrl: './expiring-meds-widget.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: '../resizable-notifications-widget/resizable-notifications-widget.component.scss',
})
export class ExpiringMedsWidgetComponent {

    http = inject(HttpClient);

    hasBeenInitialized = false;
    isLoading = true;
    expiringMeds: WidgetExpiredMedicationVm[] = [];
    faArrowUpRIghtFromSquare = faArrowUpRightFromSquare

    ngOnInit() { this.initialize(); }


    initialize(): void {
        this.http.get<SystemMessage>('api/Admin/Widgets/GetExpiringMedications').subscribe((msg: SystemMessage) => {
            this.isLoading = false;
            this.expiringMeds = msg.model;
        })
    }

    goToLotExp(expiringMed: WidgetExpiredMedicationVm) {
        return `pharmacy/inventories/products/edit/${expiringMed.productId}/${expiringMed.inventorySiteId}?tab=Lot%20%23s%20%2F%20Exp.%20Dates%20%2F%20Serial%20%23s`;
    }

    goToExpirationReport() { window.open('pharmacy/reports/expiration', '_blank'); }
}
